class SbTopBar {
  constructor() {
    this.init();
  }
  
  init() {
    this.cacheDom();
    this.events();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.buildNav());
    } else {
      this.buildNav();
    }

    this.updateVisibility();

    document.addEventListener('on:variant:change', (event) => {
      fetch("/products/"+event.detail.product.handle+"?sections=main-product&variant="+event.detail.variant.id)
        .then(res => res.json())
        .then(data => {
          const html = data['main-product'];
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newBottomBarPrice = tempDiv.querySelector('.sb-bottom-bar .product-price--large');
          const newTopBarPrice = tempDiv.querySelector('.sb-top-bar .product-price--large');
          const existingBottomBarPrice = document.querySelector('.sb-bottom-bar .product-price--large');
          const existingTopBarPrice = document.querySelector('.sb-top-bar .product-price--large');
      
          if (existingBottomBarPrice) {
            existingBottomBarPrice.innerHTML = newBottomBarPrice.innerHTML;
          }
          if (existingTopBarPrice) {
            existingTopBarPrice.innerHTML = newTopBarPrice.innerHTML;
          }
        })
    });
  }
  
  cacheDom() {
    this.lastScrollTop = 0;
    this.topBar = document.querySelector('.sb-top-bar');
    this.bottomBar = document.querySelector('.sb-bottom-bar');
    this.productDetails = document.querySelector('.product-info');
    this.productDetailsMobile = document.querySelector('.product-info');
    this.backButton = document.querySelector('#sb-back-button');
    this.cartButton = document.querySelector('#sb-cart-button');
    this.backButtonBottom = document.querySelector('#st-back-button');
    this.cartButtonBottom = document.querySelector('#st-cart-button');
    this.cartButtonMain = document.querySelector('.product-info__add-button button');
    this.cartButtonBottom = document.querySelector('#st-cart-button');
    this.cartButtonMain = document.querySelector('.product-info__add-button button');
  }
  
  events() {
	window.onscroll = this.updateVisibility.bind(this);
    
    if(this.backButton) this.backButton.addEventListener('click', () => this.scrollToTop(), { passive: true });

    if(this.cartButton) {
      this.cartButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.cartButtonMain.click();
        this.scrollToTop()
      });
    }

    if(this.backButtonBottom) this.backButtonBottom.addEventListener('click', () => this.scrollToForm(), { passive: true });

    if(this.cartButtonBottom) {
      this.cartButtonBottom.addEventListener('click', (e) => {
        e.preventDefault();
        this.cartButtonMain.click();
        this.scrollToForm()
      });
    }
  }
  
  buildNav() {
    const block = document.querySelector('.product-details__block');
    if (!block) return;

    const navContainer = document.getElementById('sb-top-bar-nav');
    if (!navContainer) return;

    this.navBlocks = [];

    block.querySelectorAll('summary .disclosure__title').forEach((titleEl) => {
      const scrollTarget = titleEl.closest('details') || titleEl;
      const title = titleEl.textContent.trim();
      const link = document.createElement('a');
      link.className = 'sb-top-bar__nav-link';
      link.textContent = title;
      link.href = '#';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const stickyHeader = document.querySelector('.cc-header--sticky');
        const offset = (stickyHeader ? stickyHeader.getBoundingClientRect().height : 0)
          + (this.topBar ? this.topBar.getBoundingClientRect().height : 0);
        const top = scrollTarget.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      });

      navContainer.appendChild(link);
      this.navBlocks.push({ block: scrollTarget, link });
    });
  }

  updateNavActive() {
    if (!this.navBlocks || !this.navBlocks.length) return;

    const scrollY = window.scrollY;
    const stickyHeader = document.querySelector('.cc-header--sticky');
    const offset = (stickyHeader ? stickyHeader.getBoundingClientRect().height : 0)
      + (this.topBar ? this.topBar.getBoundingClientRect().height : 0) + 2;
    let activeIndex = 0;

    this.navBlocks.forEach(({ block }, index) => {
      const blockTop = block.getBoundingClientRect().top + scrollY;
      if (scrollY + offset >= blockTop) {
        activeIndex = index;
      }
    });

    this.navBlocks.forEach(({ link }, index) => {
      link.classList.toggle('active', index === activeIndex);
    });
  }

  updateVisibility() {
    const scrollDepth = window.scrollY;
    const productDetailsHeight = this.topBar.getBoundingClientRect().height;
    const productDetailsMobileHeight = this.productDetailsMobile.getBoundingClientRect().height;

    if (scrollDepth > productDetailsHeight) {
      this.topBar.classList.add('active');  
    } else {
      this.topBar.classList.remove('active'); 
    }

    if(scrollDepth > 1000) {
      this.bottomBar.classList.add('active');
    } else {
      this.bottomBar.classList.remove('active'); 
    }

    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st <= this.lastScrollTop) {
      this.topBar.classList.add('up');  
    } else {
      this.topBar.classList.remove('up');  
    }
    this.lastScrollTop = st <= 0 ? 0 : st;

    this.updateNavActive();
  }
  
  scrollToTop() {
    document.body.scrollIntoView({ behavior: 'smooth' }); 
  }
  
  scrollToForm() {
    this.productDetailsMobile.scrollIntoView({ behavior: 'smooth' }); 
  }
}

const sbTopBar = new SbTopBar();